import React from "react"
import TextField from "../../components/TextField"
import Button from "../../components/Button"
import { Mutation } from "react-apollo"
import ADD_DEVICE from "../../graphql/addDevice.graphql"

class AddDevice extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      deviceName: "",
      error: null,
    }
  }

  validateDeviceName = () => {
    this.setState(({ deviceName }) => ({
      error: !deviceName ? "Required" : undefined,
    }))
  }

  updateDevice = (e) => {
    const deviceName = e.target.value
    this.setState({ deviceName, error: null })
  }

  onDeviceSubmit = (e) => {
    e && e.preventDefault()
    this.validateDeviceName()

    let { deviceName } = this.state

    if (this.state.deviceName) {
      this.props
        .addDevice({
          variables: { deviceName },
        })
        .then(({ data }) => {
          let { message, payload } = data.addDevice.response

          if (payload === "success") {
            this.props.onSubmit()
          } else if (payload === "deviceNameTaken") {
            this.setState({ error: message })
          } else {
            throw new Error(message)
          }
        })
        .catch((error) => console.log(error))
    }
  }

  render() {
    return (
      <form onSubmit={this.onDeviceSubmit}>
        <TextField
          fullWidth
          placeholder='e.g. "Work Laptop"'
          type="text"
          value={this.state.deviceName}
          onChange={this.updateDevice}
          errors
          errorOptions={{
            outline: true,
            showMessage: true,
            message: this.state.error,
            hasError: !!this.state.error,
          }}
          dataCy={"register-device-input"}
        />
        <Button
          classes={["dark-fill", "small-caps"]}
          fullWidth
          action={this.onDeviceSubmit}
          data-cy={"register-device-button"}
        >
          Add Device
        </Button>
      </form>
    )
  }
}

const AddDeviceWithData = (props) => (
  <Mutation mutation={ADD_DEVICE}>
    {(mutate) => <AddDevice {...props} addDevice={mutate} />}
  </Mutation>
)
export default AddDeviceWithData
